import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: 16
			},
			border: {
				padding: "5px 0px",
				borderBottom: `1px solid ${theme.palette.grey["A700"]}`
			},
			title: {
				fontWeight: 500,
				fontSize: 16,
				color: theme.palette.primary.contrastText
			},
			tag: {
				fontSize: 10,
				color: theme.palette.common.white,
				background: theme.palette.error.main,
				padding: "0px 7px",
				borderRadius: 4,
				alignItems: "center",
				display: "flex"
			},
			text: {
				color: theme.palette.primary.contrastText,
				fontSize: 14
			},
			textTime: {
				color: "#7D7D7D",
				fontSize: 12,
				margin: "10px 0px"
			}
		}),
	{
		name: "NotificationItem",
		index: 1
	}
);

export default useStyles;
